import { useEffect } from 'react';
import useApi from './useApi';
import { useAppStore } from '../context/AppContext';
import { AppFeatureBM } from '../types/BusinessModel/AppFeature/AppFeatureBM';
import { createAppFeatureList } from '../factory/AppFeatureFactory';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';
import { AppFeature } from 'src/types/ViewModel/AppFeature/AppFeature';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { state, getApiData } = useApi();
    const { setAppFeatureSettings, setServerAppFeatureSettings } = useAppStore();
    const { processApiEndpointError } = apiEndpointUtils();

    const getAppFeatures = () => {
        getApiData({
            endpoint: apiEndpoints['getAppFeatures'].url,
        });
    };

    useEffect(() => {
        if (state.status === 'success') {
            const appFeatureBM = state.result as unknown as AppFeatureBM[];
            const appFeatures = createAppFeatureList(appFeatureBM);

            const selectedAppFeatures: AppFeature[] = JSON.parse(localStorage.getItem('selectedFeatures'));
            if (selectedAppFeatures) {
                setAppFeatureSettings(selectedAppFeatures);
            } else {
                setAppFeatureSettings(appFeatures);
            }

            setServerAppFeatureSettings(appFeatures);
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { state, getAppFeatures };
};
